import { FormControl, FormHelperText } from '@mui/material';
import { Controller } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import styled from 'styled-components';
import { FormInputProps } from './InputInterface';
import DabaduTooltip from 'sharedComponents/toolTip';

const DabaduFormControl = styled(FormControl)`
  &.MuiFormControl-root {
    width: 100%;
    .form-control {
      height: auto;
      padding: 18px 20px;
      width: 100%;
      border-radius: 4px;
      font-weight: 300;
      font-size: 1rem;
      letter-spacing: 0;
      line-height: 1.4;
      font-family: ${(props) => props.theme.fonts.primary};
      color: ${(props) => props.theme.colors.textColor};
      border-width: 1px;
      border-style: solid;
      border-color: ${(props) => props.theme.colors.inputBorder};

      @media (max-width: 1650px) {
        padding: 12px 14px;
      }
    }
  }
  & .MuiFormHelperText-root {
    margin-left: 0;
  }
`;

export const CommonNumberInput = ({
  name,
  control,
  label,
  placeholder,
  rules,
  hint,
  thousandSeparator = true,
  triggerValidationForField,
  inputRef,
  maxLength,
  externalOnChange,
}: FormInputProps) => {
  return (
    <>
      {label && (
        <label className='control-label'>
          {label}
          {hint && (
            <DabaduTooltip title={hint} placement='top-end' className='tooltip-wrapper'>
              <span>
                <span className='tooltip-wrapper__text'>i</span>
              </span>
            </DabaduTooltip>
          )}
        </label>
      )}
      <DabaduFormControl component='fieldset' required={Boolean(rules)} error={Boolean(rules)}>
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <>
              <NumericFormat
                getInputRef={inputRef}
                inputMode='decimal'
                allowNegative={false}
                allowLeadingZeros={true}
                thousandSeparator={thousandSeparator}
                className='form-control'
                placeholder={placeholder}
                value={value}
                onValueChange={(values) => {
                  onChange(values.value);
                  triggerValidationForField(name);

                  if (externalOnChange) {
                    const indexVal = parseInt(name?.match(/\d+/)[0], 10);
                    externalOnChange(indexVal, values.value);
                  }
                }}
                maxLength={maxLength}
              />

              {Boolean(error?.message) && <FormHelperText>{error?.message}</FormHelperText>}
            </>
          )}
        />
      </DabaduFormControl>
    </>
  );
};
